import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import Home from './components/Home';
import AboutSection from './components/AboutSection';
import MonthlySevaForm from './components/MonthlySevaForm';
import Youth from './components/Youth';
import ContactUs from './components/ContactUs';
import Calendar from './components/CalendarComponent';
import Gallery from './components/Gallery';
import DailyDarshan  from './components/DailyDarshan';
import Goshala from './components/Goshala';
import Deities from './components/DeitiesDress';
import GuestHouse from './components/GuestHouse';
import Govindas from './components/Govindas';
import AboutPage  from './components/AboutIskconUjn';
import SrilaPrabhupada  from './components/SrilaPrabhupada';
import BcsSwamis  from './components/BcsSwamis';
import Footer from './components/Footer';
import WhatsAppFloatButton from './components/WhatsAppFloatButton';
import './assets/styles/style.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

function App() {
  return (
    <Router>
      <ScrollToTop /> {/* Add this just inside <Router> */}
      <Header />
      <div>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutSection />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/youthservices" element={<Youth />} />
          <Route path="/MonthlySevaForm" element={<MonthlySevaForm />} />
          <Route path="/DailyDarshan" element={<DailyDarshan />} />
          <Route path="/services/goshala" element={<Goshala />} />
          <Route path="/services/guesthouse" element={<GuestHouse />} />
          <Route path="/services/deities" element={<Deities />} />
          <Route path="/services/Govindas" element={<Govindas />} />
          <Route path="/about/iskconujjain" element={<AboutPage />} />
          <Route path="/about/SrilaPrabhupada" element={<SrilaPrabhupada />} />
          <Route path="/about/bcsSwami" element={<BcsSwamis />} />
          </Routes>
          <WhatsAppFloatButton phoneNumber="919876543210" />
      </div>
      <Footer />
    </Router>
  );
}

export default App;
